export const state = () => ({
  ticket: {},
  tickets: [],
})

export const actions = {
  async saveTicket({ commit }, routeParams) {
    await this.$axios.post('tickets/create', routeParams)
  },
  async getTickets({ commit }) {
    const params = { page: 1, limite: -1 }
    const { data } = await this.$axios.post('tickets/getMyTickets', params)
    commit('setTickets', data.tickets)
  },
  async getTicket({ commit }, { id }) {
    const params = { id }
    const { data } = await this.$axios.post('tickets/getTicket', params)
    commit('setTicket', data.ticket)
  },
}

export const mutations = {
  setTickets(state, data) {
    state.tickets = data
  },
  setTicket(state, data) {
    state.ticket = data
  },
}
